<template>
	<div id="customer-webPay-container">
		<div v-if="!isMobile">
			<table class="customer-webPay-list" v-if="customerWebPayList?.rows?.length > 0">
				<tr class="header-row sticky">
					<th>User ID</th>
					<th>Transaction ID</th>
					<th>Provider Transaction ID</th>
					<th>Transaction Date Time</th>
					<th>Phone Number</th>
					<th>Provider</th>
					<th>Amount</th>
					<th>Result</th>
					<th>Extra Information</th>
				</tr>
				<tr class="data-row" v-for="(customer, index) in customerWebPayList.rows" :key="index">
					<td>{{ customer.userId }}</td>
					<td>{{ customer.monetaryTransactionId }}</td>
					<td> {{ customer.providerTransactionId }}</td>
					<td> {{ new Date(customer.initiationDate).toLocaleTimeString([], shortDateOptions) }}</td>
					<td>{{ customer.phoneNumber }}</td>
					<td>{{ customer.provider }}</td>
					<td>{{ customer.fromPlayerCashCOC }}</td>
					<td>{{ customer.status }}</td>
					<td>{{ customer.statusAdditionalInfo }}</td>
				</tr>
			</table>
			<div v-else>
				<h2 class="no-records">No Customer WebPay Records for this date range.</h2>
			</div>
		</div>
		
		<div v-if="isMobile">
			<table v-if="customerWebPayList?.rows?.length > 0" class="customer-webPay-list black-text separate-tables" v-for="(customer, index) in customerWebPayList.rows">
				<tr>
					<th>User ID</th>
					<td>{{ customer.userId }}</td>
				</tr>
				<tr>
					<th>Transaction ID</th>
					<td>{{  customer.monetaryTransactionId }}</td>
				</tr>
				<tr>
					<th>Provider Transaction ID</th>
					<td>{{ customer.providerTransactionId }}</td>
				</tr>
				<tr>
					<th>Transaction Date Time</th>
					<td>{{ new Date(customer.initiationDate).toLocaleTimeString([], shortDateOptions) }}</td>
				</tr>
				<tr>
					<th>Phone Number</th>
					<td>{{ customer.phoneNumber }}</td>
				</tr>
				<tr>
					<th>Provider</th>
					<td>{{ customer.provider }}</td>
				</tr>
				<tr>
					<th>Amount</th>
					<td>{{ customer.fromPlayerCashCOC }}</td>
				</tr>
				<tr>
					<th>Result</th>
					<td>{{ customer.status }}</td>
				</tr>
				<tr>
					<th>Extra Information</th>
					<td>{{ customer.statusAdditionalInfo }}</td>
				</tr>
			</table>
			<div v-else>
				<h2 class="no-records">No Customer WebPay Records for this date range.</h2>
			</div>
		</div>
		
	</div>
</template>

<script>
export default {
	name: "CustomerWebPayTable",
	inheritAttrs: false,
	props: {
		customerWebPayList: Object,
		inGameCurrencyTool: Object,
		systemCurrencyTool: Object,
		isMobile: Boolean
	},
	data() {
		return {
			systemMinorWholeOrFull: this.systemCurrencyTool.displayType.minorWholeOrFull,
			systemFull: this.systemCurrencyTool.displayType.full,
		};
	},
	watch: {
		customerWebPayList() {
			//console.log("the list", this.customerWebPayList);
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sticky {
	top: -16px;
}

#customer-webPay-container {
	position: relative;
	margin-bottom: 15px;
	padding: 15px;
	background-color: #ddd;
	white-space: break-spaces;
	overflow: auto;
}

.customer-webPay-list {
	width: 100%;
	font-size: 14px;
	text-align: left;
	border-collapse: collapse;
}

.customer-webPay-list th,
.customer-webPay-list td {
	border: 1px #000 solid;
	padding: 5px 10px;
}

.customer-webPay-list tr.data-row {
	color: #000;
}

.customer-webPay-list tr:nth-child(2n) {
	background-color: #bfbfbf;
}

.header-row {
	background-color: #525252;
	color: #fff;
}

.header-row th {
	border-color: #fff #fff #000;
}

.no-records {
	color: #000;
}

.right-align {
	text-align: right;
}

.left-align {
	text-align: left;
}

.center-align {
	text-align: center;
}

.black-text {
	color: black;
}
.separate-tables {
	margin-bottom: 35px;
}
</style>
